import { NavLink } from 'react-router-dom';
import { LogoShieldIcon } from '../../assets/icons';

/** Client Admin sections. */
const ITEMS = [
  { to: '/client', label: 'Setup checklist', end: true },
  { to: '/client/departments', label: 'Departments' },
  { to: '/client/party', label: 'Party hierarchy' },
  { to: '/client/team', label: 'Team & access' },
  { to: '/client/gaps', label: 'Key people & gaps' },
  { to: '/client/resources', label: 'Resources' },
];

const linkClass = (isActive: boolean) =>
  [
    'flex items-center rounded-lg px-4 py-3 text-sm font-medium no-underline transition-colors',
    isActive ? 'bg-brand-shade text-brand' : 'text-ink-secondary hover:bg-brand-shade/60 hover:text-brand',
  ].join(' ');

interface SidebarProps {
  open?: boolean;
  onClose?: () => void;
}

export default function ClientSidebar({ open = false, onClose }: SidebarProps) {
  return (
    <>
      {open && (
        <div className="fixed inset-x-0 bottom-0 top-16 z-20 bg-black/30 lg:hidden" onClick={onClose} aria-hidden />
      )}
      <aside
        className={[
          'fixed left-0 top-16 z-30 flex h-[calc(100vh-64px)] w-[280px] flex-col gap-5 overflow-y-auto border-r border-line-soft bg-white pl-4 pr-[17px] py-4 transition-transform duration-200 lg:z-10 lg:translate-x-0',
          open ? 'translate-x-0' : '-translate-x-full',
        ].join(' ')}
      >
        <div className="flex flex-col gap-2.5 rounded-xl bg-brand-shade p-3.5">
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center rounded-lg bg-brand p-2 text-white">
              <LogoShieldIcon className="size-5" />
            </span>
            <div className="flex flex-col">
              <span className="text-xs font-bold leading-4 text-ink">CHUNAAV</span>
              <span className="text-[10px] font-medium uppercase leading-[15px] tracking-[0.5px] text-brand">
                Client Admin
              </span>
            </div>
          </div>
          <div className="flex gap-1 rounded-lg border border-[#dbe6fb] bg-white p-[3px]">
            <span className="flex-1 rounded-md bg-white px-3 py-1.5 text-center text-xs font-semibold text-ink">
              Client setup
            </span>
          </div>
        </div>

        <nav className="flex flex-col gap-1" aria-label="Sections">
          {ITEMS.map(({ to, label, end }) => (
            <NavLink key={to} to={to} end={end} onClick={onClose} className={({ isActive }) => linkClass(isActive)}>
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
}
